export const CREATE_CONTACT = "createContact";
export const OPEN_MODAL = "openModal";
